import {
  fieldValueOf,
  momentToString,
  stringToMoment,
  toPostalCode,
  toPostalCodeUpper,
  toPostalCodeLower,
} from '@arch-log/webapp.modules/utils/entity/Helper'

import * as ModelFields from '@arch-log/webapp.modules/project/model/fields'
import * as EntityFields from './fields'

import * as Address from '@arch-log/webapp.modules/address/entity'

const addressEntityFieldMapping = {
  [Address.Fields.PostalCode]: EntityFields.PostalCode,
  [Address.Fields.StateOrPrefecture]: EntityFields.StateOrPrefecture,
  [Address.Fields.City]: EntityFields.City,
  [Address.Fields.Street]: EntityFields.Street,
  [Address.Fields.Building]: EntityFields.Building,
}

/**
 */
export const entityToModel = (entity) => ({
  ...entity,
  [ModelFields.Id]: fieldValueOf(entity, EntityFields.Id, null),
  [ModelFields.Name]: fieldValueOf(entity, EntityFields.Name, null),
  [ModelFields.PropertyType]: fieldValueOf(
    entity,
    EntityFields.PropertyType,
    null,
  ),
  [ModelFields.ConstructionArea]: fieldValueOf(
    entity,
    EntityFields.ConstructionArea,
    null,
  ),
  [ModelFields.ConstructionType]: fieldValueOf(
    entity,
    EntityFields.ConstructionType,
    null,
  ),
  [ModelFields.GroundFloors]: fieldValueOf(
    entity,
    EntityFields.GroundFloors,
    null,
  ),
  [ModelFields.BasementFloors]: fieldValueOf(
    entity,
    EntityFields.BasementFloors,
    null,
  ),
  [ModelFields.ConstructionStartDate]: stringToMoment(
    fieldValueOf(entity, EntityFields.ConstructionStartDate, null),
  ),
  [ModelFields.ConstructionEndDate]: stringToMoment(
    fieldValueOf(entity, EntityFields.ConstructionEndDate, null),
  ),
  // address
  ...Address.Converter.entityToModel(entity, {
    entityFieldMapping: addressEntityFieldMapping,
  }),
})

/**
 */
export const modelToEntity = (model) => ({
  [EntityFields.Id]: fieldValueOf(model, ModelFields.Id, null),
  [EntityFields.Name]: fieldValueOf(model, ModelFields.Name, null),

  [EntityFields.ConstructionStartDate]: stringToMoment(
    fieldValueOf(model, ModelFields.ConstructionStartDate, null),
  ),
  [EntityFields.PropertyType]: fieldValueOf(
    model,
    ModelFields.PropertyType,
    null,
  ),
  [EntityFields.ConstructionArea]: fieldValueOf(
    model,
    ModelFields.ConstructionArea,
    null,
  ),
  [EntityFields.ConstructionType]: fieldValueOf(
    model,
    ModelFields.ConstructionType,
    null,
  ),
  [EntityFields.GroundFloors]: fieldValueOf(
    model,
    ModelFields.GroundFloors,
    null,
  ),
  [EntityFields.BasementFloors]: fieldValueOf(
    model,
    ModelFields.BasementFloors,
    null,
  ),

  [EntityFields.ConstructionStartDate]: momentToString(
    fieldValueOf(model, ModelFields.ConstructionStartDate, null),
  ),
  [EntityFields.ConstructionEndDate]: momentToString(
    fieldValueOf(model, ModelFields.ConstructionEndDate, null),
  ),
  ...Address.Converter.modelToEntity(model, {
    entityFieldMapping: addressEntityFieldMapping,
  }),
})
